// extracted by mini-css-extract-plugin
export default {"component":"CreateUserNameLogout_component__L2dxF"};